<template>
    <div class="register-box">
        <div class="register-logo">
            <a :href="meta.homeUrl"><b>{{ meta.appName }}</b></a>
        </div>

        <div class="card">
            <div class="card-body register-card-body">
                <p class="login-box-msg">註冊稽查員帳號</p>

                <div class="input-group mb-3">
                    <input type="text" id="name" :class="['form-control', { 'is-invalid': hasServerError('name') }]"
                           placeholder="姓名" v-model="form.name" @input="clearServerError('name')"
                           @keyup.enter="send" autofocus>
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <span class="fas fa-user"></span>
                        </div>
                    </div>
                    <div class="tooltip fade bottom-right" :class="[required(form.name) ? 'show' : 'hide']"
                         role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">請填寫姓名</div>
                    </div>
                    <div class="tooltip fade bottom-right" :class="[hasServerError('name') ? 'show' : 'hide']"
                         role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">{{ getServerError('name') }}</div>
                    </div>
                </div>
                <div class="input-group mb-3">
                    <input type="text" id="email"
                           :class="['form-control', { 'is-invalid': hasServerError('email') }]"
                           placeholder="信箱" v-model="form.email" @input="clearServerError('email')"
                           @keyup.enter="send">
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <span class="fas fa-envelope"></span>
                        </div>
                    </div>
                    <div class="tooltip fade bottom-right" :class="[required(form.email) ? 'show' : 'hide']"
                         role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">請填寫信箱</div>
                    </div>
                    <div class="tooltip fade bottom-right" :class="[!isMail(form.email) ? 'show' : 'hide']"
                         role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">非法的信箱格式</div>
                    </div>
                    <div class="tooltip fade bottom-right" :class="[hasServerError('email') ? 'show' : 'hide']"
                         role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">{{ getServerError('email') }}</div>
                    </div>
                </div>
                <div class="input-group mb-3">
                    <input type="password" id="password"
                           :class="['form-control', { 'is-invalid': hasServerError('password') }]"
                           placeholder="密碼" v-model="form.password" @input="clearServerError('password')"
                           @keyup.enter="send">
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <span class="fas fa-lock"></span>
                        </div>
                    </div>
                    <div class="tooltip fade bottom-right" :class="[required(form.password) ? 'show' : 'hide']"
                         role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">請填寫密碼</div>
                    </div>
                    <div class="tooltip fade bottom-right" :class="[min(form.password, 6) ? 'show' : 'hide']"
                         role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">至少填寫6碼</div>
                    </div>
                    <div class="tooltip fade bottom-right" :class="[hasServerError('password') ? 'show' : 'hide']"
                         role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">{{ getServerError('password') }}</div>
                    </div>
                </div>
                <div class="input-group mb-3">
                    <input type="password" id="retypePassword"
                           :class="['form-control', { 'is-invalid': hasServerError('password_confirmation') }]"
                           placeholder="確認密碼" v-model="form.password_confirmation"
                           @input="clearServerError('password_confirmation')" @keyup.enter="send">
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <span class="fas fa-sign-in-alt"></span>
                        </div>
                    </div>
                    <div class="tooltip fade bottom-right"
                         :class="[confirmPassword(form.password, form.password_confirmation) ? 'show' : 'hide']"
                         role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">兩次密碼需填寫一致</div>
                    </div>
                    <div class="tooltip fade bottom-right"
                         :class="[hasServerError('password_confirmation') ? 'show' : 'hide']" role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">{{ getServerError('password_confirmation') }}</div>
                    </div>
                </div>
                <div class="input-group mb-3">
                    <input type="text" id="tel" :class="['form-control', { 'is-invalid': hasServerError('tel') }]"
                           placeholder="電話" v-model="form.tel" @input="clearServerError('tel')"
                           @keyup.enter="send">
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <span class="fas fa-phone"></span>
                        </div>
                    </div>
                    <div class="tooltip fade bottom-right" :class="[required(form.tel) ? 'show' : 'hide']"
                         v-show="required(form.tel)" role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">請填寫電話</div>
                    </div>
                    <div class="tooltip fade bottom-right" :class="[hasServerError('tel') ? 'show' : 'hide']"
                         role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">{{ getServerError('tel') }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <a :href="meta.loginUrl" class="text-center">已有帳號</a>
                    </div>
                    <div class="col-4">
                        <button type="button" class="btn btn-success btn-block" @click="send">註冊</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const $ = window.$;

export default {
    name: 'RegisterApp',
    props: {
        initialData: {
            type: Object,
            required: true
        }
    },
    data() {
        const data = this.initialData ? JSON.parse(JSON.stringify(this.initialData)) : {};
        if(!data.form)
            data.form = {};
        if(!data.meta)
            data.meta = {};
        if(!data.serverErrors)
            data.serverErrors = {};
        if(typeof data.isSend === 'undefined')
            data.isSend = false;
        return data;
    },
    methods: {
        send() {
            this.isSend = true;
            this.serverErrors = {};
            let $scrollTag = $('body'), $focusTag = null;
            if(!this.form.name)
                $focusTag = $('#name');
            else if(!this.form.email)
                $focusTag = $('#email');
            else if(!this.isMail(this.form.email))
                $focusTag = $('#email');
            else if(!this.form.password)
                $focusTag = $('#password');
            else if(this.form.password != this.form.password_confirmation)
                $focusTag = $('#retypePassword');
            else if(!this.form.tel)
                $focusTag = $('#tel');

            if($focusTag) {
                $scrollTag.animate({
                    scrollTop: $focusTag.offset().top
                }, 200, function() {
                    $focusTag.focus();
                });
                return;
            }

            const $loader = $('.register-card-body').loadingIndicator().data('loadingIndicator');
            $loader.show();
            const self = this;
            $.ajax({
                method: 'POST',
                url: this.baseUrl + '/user/register',
                data: this.form
            }).done((data) => {
                if(data && data.error === 0) {
                    $.toast({
                        heading: '儲存成功',
                        text: data.datetime,
                        position: 'top-center',
                        loader: false,
                        icon: 'success'
                    });

                    location.href = data.url || self.baseUrl + '/user/reviewing';
                } else {
                    $.toast({
                        heading: '發生錯誤',
                        text: data && data.message ? data.message : '系統忙碌中，請稍後再試',
                        position: 'top-center',
                        loader: false,
                        icon: 'error'
                    });
                }
            }).fail((jqXHR) => {
                if(jqXHR.status == 422) {
                    const responseJson = jqXHR.responseJSON || {};
                    this.serverErrors = responseJson.errors || {};

                    $.toast({
                        heading: '資料驗證失敗',
                        text: this.firstValidationMessage(this.serverErrors) ||
                            responseJson.message ||
                            '部分欄位填寫有誤，請確認後再送出',
                        position: 'top-center',
                        loader: false,
                        icon: 'error'
                    });

                    this.focusFirstServerError();
                } else {
                    $.toast({
                        heading: '連線異常',
                        text: '請檢查網路是否正常',
                        position: 'top-center',
                        loader: false,
                        icon: 'error'
                    });
                }
            }).always(() => {
                $loader.hide();
            });
        },
        hasServerError(key) {
            return !!(
                this.serverErrors &&
                Array.isArray(this.serverErrors[key]) &&
                this.serverErrors[key].length > 0
            );
        },
        getServerError(key) {
            return this.hasServerError(key) ? this.serverErrors[key][0] : '';
        },
        clearServerError(key) {
            if(this.serverErrors && this.serverErrors[key])
                this.$delete(this.serverErrors, key);
        },
        firstValidationMessage(errors) {
            const order = ['name', 'email', 'password', 'password_confirmation', 'tel'];
            for(const key of order) {
                if(Array.isArray(errors[key]) && errors[key].length > 0)
                    return errors[key][0];
            }
            const keys = Object.keys(errors || {});
            if(keys.length > 0 && Array.isArray(errors[keys[0]]) && errors[keys[0]].length > 0)
                return errors[keys[0]][0];
            return null;
        },
        focusFirstServerError() {
            const order = ['name', 'email', 'password', 'password_confirmation', 'tel'];
            for(const key of order) {
                if(this.hasServerError(key)) {
                    this.focusField(key);
                    return;
                }
            }
        },
        focusField(key) {
            const idMap = {
                password_confirmation: 'retypePassword'
            };
            const inputId = idMap[key] || key;
            const $focusTag = $('#' + inputId);
            if($focusTag.length > 0) {
                $('body').animate({
                    scrollTop: $focusTag.offset().top
                }, 200, function() {
                    $focusTag.focus();
                });
            }
        },
        required(val) {
            let isInvalid = false;
            if(!val)
                isInvalid = true;
            return this.isSend && isInvalid;
        },
        confirmPassword(first, second) {
            let isInvalid = false;
            if(first != second)
                isInvalid = true;
            return this.isSend && isInvalid;
        },
        min(val, length) {
            let isInvalid = false;
            if(val && val.length < length)
                isInvalid = true;
            return this.isSend && isInvalid;
        },
        isMail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return !this.isSend || re.test(email);
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/RegisterApp.vue